import { render, staticRenderFns } from "./TeamModal.vue?vue&type=template&id=503dacf9&scoped=true&"
import script from "./TeamModal.vue?vue&type=script&lang=js&"
export * from "./TeamModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamModal.vue?vue&type=style&index=0&id=503dacf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503dacf9",
  null
  
)

export default component.exports